export default __webpack_public_path__ + "static/media/remove.641e450e.svg";